import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';

@Injectable()
export class HasPermissionService extends WebService {

    public hasPermission (element) {
        const list = JSON.parse(localStorage.getItem('permissions'));
        let visible = false;

        if(!list)
            return false;

        let itera = 0;
        list.forEach(elementList => {
            if (elementList.name === element) {
                visible = true;
            }
            itera++;
        });
        return visible;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/has-permission/has-permission.service.ts